
import { RevIllustration } from '@ds/components/Illustration'

import FormattedMessage from '@i18n/components/FormattedMessage'

import CardGuidance from '../CardGuidance'
import StepLayout from '../StepLayout'
import StepOption from '../StepOption'

export default {
  components: {
    CardGuidance,
    StepOption,
    FormattedMessage,
    StepLayout,
    RevIllustration,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stepOptionsClasses: (step) => {
      if (step.id === 'color') {
        return 'grid grid-cols-2 gap-x-3'
      }

      return ''
    },
  },
}
